import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
// 引入Font Awesome图标库
import '@fortawesome/fontawesome-free/css/all.css';

createApp(App).use(router).mount('#app');
